"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPurchasePercentageRateEvaluator = exports.checkPurchasePercentageRateConfigErrors = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const RequiredIntermediateFields_1 = require("./RequiredIntermediateFields");
/**
 * Purchase Percentage Rate formulas can use variables from baseFields and intermediate calcs.
 * This functions checks for any missing dependencies found in purchase percentage rate formulas.
 */
const checkPurchasePercentageRateConfigErrors = ({ purchasePercentageRateConfig, intermediateCalcs, baseFields, }) => {
    const dynamicIntermediateFields = intermediateCalcs
        .map((intermediateCalc) => intermediateCalc.field)
        .filter((field) => !RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field));
    const baseFieldVars = baseFields.map((fieldConfig) => `baseFields.${fieldConfig.field}`);
    const dynamicFieldVars = dynamicIntermediateFields.map((key) => `dynamicIntermediateFields.${key}`);
    const requiredFieldVars = RequiredIntermediateFields_1.RequiredIntermediateFieldNames.map((key) => `requiredIntermediateFields.${key}`);
    const availableVariables = new Set([
        ...baseFieldVars,
        ...dynamicFieldVars,
        ...requiredFieldVars,
    ]);
    (0, common_1.finleyAssert)(purchasePercentageRateConfig.type === 'formula', `unknown purchasePercentageRateConfig.type:[${purchasePercentageRateConfig.type}]`);
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(purchasePercentageRateConfig.config.formula, availableVariables);
    return errorMessages;
};
exports.checkPurchasePercentageRateConfigErrors = checkPurchasePercentageRateConfigErrors;
const createPurchasePercentageRateEvaluator = (purchasePercentageRateConfig, f1EngineMode) => {
    // extract formula from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    (0, common_1.finleyAssert)(purchasePercentageRateConfig.type === 'formula', 'keep TS happy');
    (0, common_1.finleyAssert)(purchasePercentageRateConfig.config.engineVersion ===
        finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${purchasePercentageRateConfig.config.engineVersion} is not yet supported`);
    const formulaString = purchasePercentageRateConfig.config.formula;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString], f1EngineMode);
    const evaluateConfig = (creditFacilityReceivable) => {
        formulaEngine.setVariables(creditFacilityReceivable, { flatten: true });
        return formulaEngine.evaluateNumber(formulaString);
    };
    return {
        evaluateConfig,
    };
};
exports.createPurchasePercentageRateEvaluator = createPurchasePercentageRateEvaluator;
//# sourceMappingURL=purchasePercentageRateEvaluator.js.map